import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ReportService {
  private header = new HttpHeaders({
    Accept: "application/pdf",
    "Content-Type": "application/json",
  });
  constructor(private http: HttpClient) {}

  /**
   * reportTracing
   */
  public reportTracing(idToolbox: string | number = 6) {
    return this.http.get(
      `${environment.apiUrl}/api/reporte/toolbox/${idToolbox}/nc/seguimiento`,
      { headers: this.header, responseType: "blob" }
    );
  }

  /**
   * reportTratament
   */
  public reportTratament(
    idNC: string | number,
    idToolbox: string | number = 6
  ) {
    return this.http.get(
      `${environment.apiUrl}/api/reporte/toolbox/${idToolbox}/nc/${idNC}/tratamiento`,
      { headers: this.header, responseType: "blob" }
    );
  }

  /**
   * reportVerify
   */
  public reportVerifyAnalisis(
    idNC: string | number,
    idToolbox: string | number = 6
  ) {
    return this.http.get(
      `${environment.apiUrl}/api/reporte/toolbox/${idToolbox}/nc/${idNC}/verificacion-analisis`,
      { headers: this.header, responseType: "blob" }
    );
  }

  /**
   * name
   */
  public reportVerifyEficacia(
    idNC: string | number,
    idToolbox: string | number = 6
  ) {
    return this.http.get(
      `${environment.apiUrl}/api/reporte/toolbox/${idToolbox}/nc/${idNC}/verificacion-eficacia`,
      { headers: this.header, responseType: "blob" }
    );
  }
  /**
   * reportPlanAction
   */
  public reportPlanAction(
    idNC: string | number,
    idToolbox: string | number = 6
  ) {
    return this.http.get(
      `${environment.apiUrl}/api/reporte/toolbox/${idToolbox}/nc/${idNC}/plan-accion`,
      { headers: this.header, responseType: "blob" }
    );
  }
  /**
   * reportHistoric
   */
  public reportHistoric(idNc: string | number, idToolbox: string | number = 6) {
    return this.http.get(
      `${environment.apiUrl}/api/reporte/toolbox/${idToolbox}/nc/${idNc}/report_noconformidad_historial`,
      { headers: this.header, responseType: "blob" }
    );
  }
  /**
   * reportExecution
   */
  public reportExecution(idNc: string | number,idToolbox: string | number = 6) { 
    return this.http.get(
      `${environment.apiUrl}/api/reporte/toolbox/${idToolbox}/nc/${idNc}/report_ejecucion_report`,
      { headers: this.header, responseType: "blob" }
    );
  }
}
